import { render, staticRenderFns } from "./CustomAccordion.vue?vue&type=template&id=13b91f37&scoped=true&"
import script from "./CustomAccordion.vue?vue&type=script&lang=js&"
export * from "./CustomAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b91f37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b91f37')) {
      api.createRecord('13b91f37', component.options)
    } else {
      api.reload('13b91f37', component.options)
    }
    module.hot.accept("./CustomAccordion.vue?vue&type=template&id=13b91f37&scoped=true&", function () {
      api.rerender('13b91f37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/CustomAccordion.vue"
export default component.exports